import React, { ReactNode } from 'react';

interface BottomSheetProps {
    open: boolean;
    onClose: () => void;
    children: ReactNode;
    title?: ReactNode;
}

const BottomSheet: React.FC<BottomSheetProps> = ({ open, onClose, children, title }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-30 transition-all">
            <div
                className="w-full max-w-md mx-auto bg-white rounded-t-2xl shadow-lg p-4 animate-slideUp"
                style={{ minHeight: '40vh' }}
            >
                <div className="flex items-center justify-between mb-2">
                    {title && <div className="text-lg font-bold">{title}</div>}
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                {children}
            </div>
            <style>{`
        .animate-slideUp {
          animation: slideUp 0.3s cubic-bezier(.4,0,.2,1);
        }
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
      `}</style>
        </div>
    );
};

export default BottomSheet;
